module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/BVRatings-11517a4998b6b062f5c8ea8727baad18.png";